import OverviewComponent from "../../../../../../shared/components/overview-panel/OverviewComponent";
import {
  CLIENT_PLATFORM_MARGINS,
  TOOLS,
} from "../../../../../../shared/lib/routesResolver";
import useAxios from "../../../../../../hooks/useAxios";
import { useEffect, useState } from "react";
import { API_CLIENT_PLATFORM_MARGINS_CHANGELOG_FULL } from "../../../../../../shared/lib/apiEndpointsResolver";
import { catchFunction } from "../../../../../../shared/lib/utils";
import useLoading from "../../../../../../shared/components/loading/useLoading";
import { useTranslation } from "react-i18next";
import ClientPlatformMarginsChangelogTable from "./ClientPlatformMarginsChangelogTable";

const ClientPlatformMarginsChangelogOverview = () => {
  const axios = useAxios();
  const [changelog, setChangelog] = useState([]);
  const { setLoading } = useLoading();
  const { t } = useTranslation();

  const findChangelog = () => {
    setLoading(true);
    axios
      .get(API_CLIENT_PLATFORM_MARGINS_CHANGELOG_FULL)
      .then((response) => setChangelog(response.data))
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const breadcrumbItems = [
    {
      title: "clientPlatformMargins.overview.breadcrumb.first",
      link: TOOLS,
    },
    {
      title: "clientPlatformMargins.overview.breadcrumb.second",
      link: CLIENT_PLATFORM_MARGINS,
    },
    { title: "clientPlatformMargins.overview.breadcrumb.third" },
  ];

  const tabs = [
    {
      trigger: {
        value: `all`,
        label: t("defaults.allTab"),
      },
      content: <ClientPlatformMarginsChangelogTable data={changelog} />,
    },
  ];

  useEffect(() => {
    findChangelog();
  }, []);
  return (
    <OverviewComponent
      breadcrumbItems={breadcrumbItems}
      options={<></>}
      tabs={tabs}
    />
  );
};

export default ClientPlatformMarginsChangelogOverview;
